/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {LogDataFormComponent as ɵc} from './logdata-form/logdata-form.component';
export {LogDataComponent as ɵb} from './logdata.component';
export {declaration as ɵa} from './logdata.module';
export {LogDataRoutes as ɵd} from './logdata.routing';